
import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      style={{
        padding: "40px 20px",
        color: "#666",
        borderTop: "1px solid #eee",
        fontSize: "14px",
        backgroundColor: "#fff", // 可根据官网主体配色微调
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          display: "flex",
          flexDirection: "column", // 💡 核心：修改为纵向上下结构
          alignItems: "center",     // 💡 核心：让所有内容横向完美居中
          justifyContent: "center",
          gap: "16px",             // 上下两层之间的物理间距
          textAlign: "center",
        }}
      >
        {/* 上层：合规法律链接 */}
        <div
          style={{
            display: "flex",
            gap: "24px",           // 链接彼此之间的横向间距
            flexWrap: "wrap",      // 确保在极窄屏幕上能自动优雅换行
            justifyContent: "center",
          }}
        >
          <Link to="/tos_policy" style={linkStyle}>
            Terms of Service
          </Link>
          <Link to="/eula" style={linkStyle}>
            EULA
          </Link>
          <Link to="/privacy" style={linkStyle}>
            Privacy Policy
          </Link>
          <Link to="/refund" style={linkStyle}>
            Refund Policy
          </Link>
        </div>

        {/* 下层：版权声明 */}
        <div style={{ color: "#999", fontSize: "13px" }}>
          &copy; {new Date().getFullYear()} TabDSL.com All rights reserved.
        </div>
      </div>
    </footer>
  );
}


const linkStyle: React.CSSProperties = {
  color: "#666",
  textDecoration: "none",
  transition: "color 0.2s ease",
};